export default "__VITE_ASSET__41081ab3__"